import {
    GET_INITIAL_SHIFT,
    UPDATE_EMPLOYEE_SHIFT,
    GET_EMPLOYEE_INFO,
    UPDATE_EMPLOYEE_INFO
} from './redux.actionTypes';

export const getInitialShift = ({ handleSubmit, payload }) => ({
    type: GET_INITIAL_SHIFT,
    meta: { handleSubmit },
    payload
});

export const updateManageShifts = ({ handleSubmit, payload }) => ({
    type: UPDATE_EMPLOYEE_SHIFT,
    meta: { handleSubmit },
    payload
});

export const getEmployeeInfo = ({ handleSubmit, payload }) => ({
    type: GET_EMPLOYEE_INFO,
    meta: { handleSubmit },
    payload
});

export const updateEmployeeInfo = ({ handleSubmit, payload }) => ({
    type: UPDATE_EMPLOYEE_INFO,
    meta: { handleSubmit },
    payload
});
